import { Container, SkipButton, Step, Steps } from "./Stepper.style";

interface Props {
	steps: number;
	currentStep: number;
	onSkip?: () => void;
	skipText?: string;
	onBack?: () => void;
	backText?: string;
}

const Stepper: React.FC<Props> = ({
	steps,
	currentStep,
	onSkip,
	skipText,
	onBack,
	backText,
}) => {
	const all = [...Array(steps)];
	return (
		<Container role="tabpanel">
			<div>
				{onBack && <SkipButton onClick={() => onBack()}>{backText}</SkipButton>}
			</div>
			<Steps>
				{all.map((_step, index) => {
					return (
						<Step
							role="tab"
							key={`Step_${index}`}
							aria-controls={`Step_${index}`}
							aria-selected={index + 1 == currentStep ? "true" : "false"}
							className={index + 1 == currentStep ? "active" : undefined}
						/>
					);
				})}
			</Steps>
			<div>
				{onSkip && <SkipButton onClick={() => onSkip()}>{skipText}</SkipButton>}
			</div>
		</Container>
	);
};

export default Stepper;
